import { createSelector } from "reselect";

const selectRum = (state) => state.rum;

const selectEvents = () => createSelector(selectRum, (rumState) => rumState.events);

const selectChartFilters = () => createSelector(selectRum, (rumState) => rumState.chartFilters);

// Statistics by market
const selectConnectionsByMarket = () =>
  createSelector(selectRum, (rumState) => rumState.connectionsByMarket);
const selectDiagnosticsByMarket = () =>
  createSelector(selectRum, (rumState) => rumState.diagnosticsByMarket);
const selectFwuByMarket = () => createSelector(selectRum, (rumState) => rumState.fwuByMarket);

export {
  selectRum,
  selectEvents,
  selectChartFilters,
  selectConnectionsByMarket,
  selectDiagnosticsByMarket,
  selectFwuByMarket,
};
